import { Link } from 'react-router-dom';
import { Group, Stack, Center } from '@/components/ui/layout';
import { Text, Anchor } from '@/components/ui/core';

export interface AuthFooterProps {
  hideLinks?: boolean;
}

export function AuthFooter({ hideLinks = false }: AuthFooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <Center
      p="lg"
      style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10,
      }}
    >
      <Stack align="center" gap="xs">
        {!hideLinks && (
          <Group gap="md">
            <Anchor component={Link} to="/privacy" size="sm" c="dimmed">
              Privacy Policy
            </Anchor>
            <Text c="dimmed" size="sm">•</Text>
            <Anchor component={Link} to="/terms" size="sm" c="dimmed">
              Terms of Service
            </Anchor>
            <Text c="dimmed" size="sm">•</Text>
            <Anchor component={Link} to="/help" size="sm" c="dimmed">
              Help
            </Anchor>
          </Group>
        )}
        <Text size="xs" c="dimmed" ta="center">
          © {currentYear} CCMS. All rights reserved.
        </Text>
      </Stack>
    </Center>
  );
}

export default AuthFooter;
